const toggleOneTrustSettings = () => {
  // eslint-disable-next-line no-undef
  window.OneTrust.ToggleInfoDisplay()
}

export default toggleOneTrustSettings
